import React from "react";

export const ChartersPageFSecondSection = () => {
  return (
    <section id="charter-content" className="CharterContent">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p>
              <b>Note</b>
            </p>
            <p>Day Trips: 4, 6, and 8 hours, Multiple Day </p>
            <p>
              Locations: Clear Lake, Galveston Bay, San Jacinto Monument,
              Galveston, Galveston ship channel, Moody Gardens
            </p>
            <p>
              All charters are a Maximum of 6 guest, no exceptions. (USCG
              regulations)
            </p>
            <br />
            <p>
              <b>4 Hour: $2000-2300</b>
            </p>
            <p>
              <b>Clear Lake, Galveston Bay as far as Redfish Island</b>
            </p>
            <ul class="custom-bullet-list">
              <li>Captain</li>
              <li>Crew</li>
              <li>Fuel</li>
              <li>Cleaning</li>
              <li>Cooler, Ice, Water</li>
            </ul>
            <br />
            <p>
              <b>6 Hour : $2700-3000</b>
            </p>
            <p>
              <b>
                Clear Lake, Galveston Bay to Redfish Island, San Jacinto
                Monument
              </b>
            </p>
            <ul class="custom-bullet-list">
              <li>Captain</li>
              <li>Crew</li>
              <li>Fuel</li>
              <li>Cleaning</li>
              <li>Cooler, Ice, Water</li>
            </ul>
            <br />
            <p>
              <b>8 Hour : $3200-3500</b>
            </p>
            <p>
              <b>
                Clear Lake, Galveston Bay, San Jacinto Monument, Galveston,
                Galveston Ship Channel, Moody Gardens
              </b>
            </p>
            <ul class="custom-bullet-list">
              <li>Captain</li>
              <li>Crew</li>
              <li>Fuel</li>
              <li>Cleaning</li>
              <li>Cooler, Ice, Water</li>
              <li>Tender (operated by crew)</li>
            </ul>
            <br />
            <ul class="custom-bullet-list">
              <p>
                Discounts are only given for multiple-day, 8-hour trips. Please
                call or email for more information.
              </p>
              <p>
                Holidays and Holiday weekends, will add an additional, mandatory
                15% charge for gratuity.
              </p>
              <p>
                We also offer longer distance, multiple day cruises, to
                locations down the Texas coast.
              </p>
              <li>3-5 day trips</li>
              <li>
                Hotel reservations required separately, no overnight stays on
                boat.
              </li>
              <li>Require a 1-month prior notice</li>
            </ul>
            <h4>
              <b>Matagorda, Texas : $10,000 plus fuel</b>
            </h4>
            <ul class="custom-bullet-list">
              <li>3 day minimum</li>
              <li>Additional $1500/day (after 3)</li>
            </ul>
            <h4>
              <b>Port Aransas, Texas : $12,000 plus fuel</b>
            </h4>
            <ul class="custom-bullet-list">
              <li>3 day minimum</li>
              <li>Additional $1500/day (after 3)</li>
            </ul>
            <h4>
              <b>Corpus Christi, Texas : $15,000 plus fuel</b>
            </h4>
            <ul class="custom-bullet-list">
              <li>5 day minimum</li>
              <li>Additional $1500/day (after 3)</li>
            </ul>
            <h4>
              <b>Lake Charles, Louisiana : $10,000 plus fuel</b>
            </h4>
            <ul class="custom-bullet-list">
              <li>3 day minimum</li>
              <li>Additional $1500/day</li>
            </ul>
            <h4>
              <b>
                Summer months (June-August) we will be offering dinner cruises
              </b>
            </h4>
            <ul class="custom-bullet-list">
              <li>2.5 hours</li>
              <li>5-7:30 PM</li>
              <li>Clear Lake only</li>
              <li>$1200 plus food</li>
            </ul>
            <p>
              Longer-Term Trips Are All Subject To A 5-Day Weather Notice. We
              Advise Clients Of Weather Conditions 5 Days Prior To Their Trip.
              Clients Will Have The Ability To Reschedule Their Trip, Or Agree
              To A Possible $1500/Day Additional Charge. Boat Will Not Run
              Through Rough Conditions. Instead, We Will Hold Up In A Marina
              Until The Weather Calms.
            </p>
            <p>
              Fuel Will Be Determined By Clients. Either We Cruise At 10knts, Or
              We Can Run At 22knts. Clients Will Pay For Fuel Used During Their
              Trip.
            </p>
            <p>
              We Will Provide Snacks, And Sandwich Ingredients, As Well As Water
              And Soft Drinks.
            </p>
            <h2>Payments</h2>
            <ul class="custom-bullet-list">
              <li>$1000 Deposit, Due Upon Booking</li>
              <li>
               The remaining balance is due on the morning of the charter, prior to the boat leaving the dock.
              </li>
            </ul>
            <h2>Cancellation Policy</h2>
            <ul class="custom-bullet-list">
              <li>Up To 72 Hours Prior To Charter, 100% Refund</li>
              <li>72-48 Hours Prior To Charter, 75% Refund</li>
              <li>48-24 Hours Prior To Charter, 50% Refund</li>
              <li>Less Than 24 Hours Prior To Charter, No Refund.</li>
              <li>
                FULL Refund If We Must Cancel The Charter Due To Weather
                Conditions. Boat Will Still Charter In Normal Windy Or Rainy
                Conditions. However, We Will Give The Charter Clients The Option
                To Reschedule Or Cancel Their Trip, For Named Weather Storms,
                Such As Tropical Storms Or Hurricanes. Thunderstorms Are Going
                To Be A Case-By-Case Situation.
              </li>
            </ul>
            <h2>Reschedule Policy</h2>
            <ul class="custom-bullet-list">

            <li>Deposit Kept On File.</li>
            <li>Up To 72 Hours Prior To Day Of Charter, No Reschedule Fee</li>
            <li>Up To 48 Hours Prior To Day Of Charter, $100 Fee</li>
            <li>Up To 24 Hours Prior To Day Of Charter, $200 Fee</li>
            <li>Morning Of Charter, $300 Fee</li>
            </ul>
            <h2>Rules</h2>
            <ul class="custom-bullet-list">
              <li>Deposit Kept On File.</li>
              <li>
                No More Than 6 Guests On Board, Total. We Don’t Make This Rule,
                It Is Set By US Cost Guard.
              </li>
              <li>
                Children Are Welcomed, However Under 12 Will Needs To Wear A
                Life Jacket At All Times. Children Are Parents Responsibility.
              </li>
              <li>
                Alcohol Is Allowed; However Glass Bottles Are Not Permitted. No
                Red Wine.
              </li>
              <li>Alcohol Is BYOB And Self Serve. We Cannot Serve You.</li>
              <li>
                It Is The Responsibility Of The Charterer, To Make Sure His/Her
                Guests Maintain Self-Control At All Times.
              </li>
              <li>
                Nothing Except Water Allowed Inside Cabin, Anywhere Outside Is
                Fine
              </li>
              <li>
                No Dark Soled Shoes. Deck Shoes Or Non Skid, Light Soled Shoes
                Are Ok
              </li>
              <li>No Boots Or Heels</li>
              <li>
                Absolutely NO Illegal Drugs Or Weapons Allowed On Board. If
                Found To Be Onboard, Charter Is IMMEDIATELY Over, With No
                Refunds. Please Leave Those Items In Vehicle Back At The Dock.
              </li>
              <li>
                Please Be Courteous To Other Boaters. Yelling At Other Boaters,
                Is Not Permitted.
              </li>
              <li>
                The Captain Of The Vessel, Reserves The Right To End The
                Charter, If Any Of These Rules Are Broken.
              </li>
            </ul>
            <h2>Items Recommended</h2>
            <ul class="custom-bullet-list">
              <li>
                Any Health Concerns, Or Medical Conditions, Please Be Sure To
                Bring Your Medicine.
              </li>
              <li>
                Dramamine If You’re Prone To Sea Sickness, Even If You Aren’t
                Sure If You Are. Better To Be Safe.
              </li>
              <li>Towels</li>
              <li>Swim Attire If You Plan On Swimming.</li>
              <li>Swim Shoes If You Plan To Get On The Beach.</li>
              <li>
                Liquid Sunscreen. Please, No Spray Sunscreen, It’s Very
                Difficult To Get Off The Boat And It Makes The Decks Slippery.
              </li>
              <li>
                Snacks And Soft Drinks, Unless On Long Term Charter, We Provide.
              </li>
              <li>
                Life Jackets. We Have USCG Regulated Life Jackets On Board,
                However If You Want To Wear Your Own, You’re Welcome To.
                Children Under 12 Need To Have A Life Jacket On At All Times.
              </li>
            </ul>
            <p>
              We Want Everyone To Have The Best Time Possible. However, Safety
              Is Our First Concern. Please Respect The Boat, Captain, And The
              Crew. We Are All Here To Make Sure Your Trip Is As Safe As
              Possible.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
